export * from './clientProfileEntriesValidationSchema.js';


// WEBPACK FOOTER //
// ./src/features/client-profile/validation-schemas/index.js